// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_Oco","cls2":"SimplePaperPodcast-cls2_KRI SimplePaperPodcast-cls1_Oco"};